// extracted by mini-css-extract-plugin
export default {"transactionCancel":"styles_transactionCancel__aHyIy","head":"styles_head__rW16u","cancellationComplete":"styles_cancellationComplete__oWDkm"};